import { useState, useEffect, useRef } from "react";
import Logo from "../../assets/img/logo.png";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader"
import { axiosReq } from "../../commons/axiosReq";
import Cookies from 'universal-cookie';
import VoiceIcon from "../../assets/icon/VoiceIcon";
import ActiveVoiceIcon from "../../assets/icon/ActiveVoiceIcon";
import AudioWave from "../../assets/img/wave.png";
import { useLocation } from "react-router-dom";

const MainPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const [accumulatedResponse, setAccumulatedResponse] = useState("");
    const chatRef = useRef(null);
    const location = useLocation();
    const cookies = new Cookies();

   const sendMessage = async () => {
    if (message.trim() === "" || isLoading) return;
    
    setIsLoading(true);
    setAccumulatedResponse("");
    
    // Add user message to chat
    const userMessage = { content: message, role: "user" };
    setMessages(prev => [...prev, userMessage]);
    setMessage("");

    try {
        const response = await fetch("http://94.182.215.124:9502/api/chat", {
        // const response = await fetch("http://195.168.1.95:9502/api/chat", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${cookies.get('token2')}`,
                'X-Frame-Options': 'Deny',
                'X-Content-Type-Options': "nosniff",
                'X-XSS-Protection': "1; mode=block",
                "Referrer-Policy": "same-origin",
                "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload"
            },
            body: JSON.stringify({
                model: "deepseek-r1",
                messages: [...messages, userMessage],
                stream: true
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let assistantMessage = { content: "", role: "assistant" };
        let inThinkingBlock = false;

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            const chunk = decoder.decode(value);
            const lines = chunk.split('\n').filter(line => line.trim() !== '');

            for (const line of lines) {
                try {
                    const parsed = JSON.parse(line);
                    if (parsed.message?.content) {
                        // Handle <think> blocks
                        const content = parsed.message.content;
                        
                        if (content.includes('<think>')) {
                            inThinkingBlock = true;
                            continue;
                        }
                        
                        if (content.includes('</think>')) {
                            inThinkingBlock = false;
                            continue;
                        }
                        
                        if (!inThinkingBlock) {
                            assistantMessage.content += content;
                            setAccumulatedResponse(prev => prev + content);
                        }
                    }
                } catch (e) {
                    console.error('Error parsing JSON:', e);
                }
            }
        }

        // Clean up any remaining thinking artifacts
        assistantMessage.content = assistantMessage.content
            .replace(/<think>.*?<\/think>/gs, '')
            .trim();

        setMessages(prev => [...prev, assistantMessage]);
        
    } catch (error) {
        console.error("Error:", error);
        setMessages(prev => [...prev, { 
            content: "متاسفانه ارتباط برقرار نشد. لطفاً دوباره تلاش کنید.", 
            role: "assistant" 
        }]);
    } finally {
        setIsLoading(false);
    }
};

    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [messages, accumulatedResponse]);

    const addLog = async (description) => {
        try {
            const dataUser = await axiosReq("user/InsertUserLog", "post", {
                Description: description,
            });
            
            if (![200, 201, 204].includes(dataUser?.status)) {
                console.error("Logging failed:", dataUser);
            }
        } catch (error) {
            console.error("Error logging:", error);
        }
    };

    return (
        <div className="h-screen flex justify-center items-center bg-gray-100 hasBackgroud">
            <div className="bg-white w-[70%] lg:w-[95%] max-w-[500px] rounded-xl h-[570px] shadow-lg flex flex-col relative">
                <div className="h-[70px] bg-[#ffe6b6] w-full rounded-t-xl flex items-center myShadow py-2 px-5">
                    <div className="w-[55px] h-[55px] bg-white rounded-full flex items-center justify-center">
                        {/* <img src={Logo} className="w-[80%] block mx-auto" alt="logo" /> */}
                    </div>
                    <span className="font-IRANYekanExtra text-[#000] text-[15px] mr-4">
                        دستیار هوشمند 
                    </span>
                </div>
                
                <div className="h-[450px] overflow-y-auto p-4 flex flex-col" id="chatBack" ref={chatRef}>
                    <div
                        key="welcome"
                        className="p-2 rounded-lg max-w-[70%] mb-2 font-IRANYekanNormal relative bg-[#f3f3f3] text-[#000] mr-auto"
                    >
                        <p>سلام! چطور می‌تونم کمکتون کنم؟</p>
                    </div>
                    
                    {messages.map((msg, index) => (
                        <div
                            key={index}
                            className={`p-2 rounded-lg max-w-[70%] mb-2 font-IRANYekanNormal relative ${
                                msg.role === "user" 
                                    ? "bg-[#dfe9ff] text-[#000] ml-auto" 
                                    : "bg-[#f3f3f3] text-[#000] mr-auto"
                            }`}
                        >
                            {msg.content}
                        </div>
                    ))}
                    
                    {isLoading && (
                        <>
                            <div className="p-2 rounded-lg max-w-[70%] mb-2 font-IRANYekanNormal relative bg-[#f3f3f3] text-[#000] mr-auto">
                                {accumulatedResponse}
                            </div>
                            <ClipLoader
                                color={"#000"}
                                loading={isLoading}
                                size={25}
                                aria-label="loading spinner"
                                className="mx-auto"
                            />
                        </>
                    )}
                </div>
                
                <div className="bg-white h-[50px] w-full absolute bottom-0 rounded-b-xl bottomShadow flex items-center py-2 px-4">
                    <input
                        className="border-none w-[95%] ml-2 font-IRANYekanMedium outline-none"
                        type="text"
                        placeholder="پیام خود را بنویسید ..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                        disabled={isLoading}
                    />
                    <button 
                        className="flex justify-end mr-2" 
                        onClick={sendMessage}
                        disabled={isLoading}
                    >
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M25.0613 2.67905C25.1616 2.27899 25.145 1.85855 25.0135 1.46765C24.8819 1.07674 24.641 0.731798 24.3192 0.473773C23.9974 0.215748 23.6084 0.0554825 23.1982 0.0120067C22.7881 -0.0314691 22.3741 0.0436715 22.0054 0.228506L1.19275 10.6348C0.834394 10.8136 0.532959 11.0888 0.322271 11.4294C0.111582 11.77 -2.67029e-05 12.1625 -2.67029e-05 12.563C-2.67029e-05 12.9635 0.111582 13.3561 0.322271 13.6966C0.532959 14.0372 0.834394 14.3124 1.19275 14.4912L22.0054 24.8975C22.3741 25.0823 22.7881 25.1575 23.1982 25.114C23.6084 25.0705 23.9974 24.9103 24.3192 24.6522C24.641 24.3942 24.8819 24.0493 25.0135 23.6584C25.145 23.2675 25.1616 22.847 25.0613 22.447L22.8818 13.7316L10.226 12.563L22.8818 11.3944L25.0613 2.67905Z"
                                fill={isLoading ? "#ccc" : "#3452A4"}
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MainPage;